import { HttpClient } from "../../http/HttpClient";
import { ApiResponse } from "../../api/types/ApiResponse";
import { ApiResponseHandler } from "../../http/services/handleApiResponse/handleApiResponse";
import { updateIdentityInfosUrl } from "../../api/prospectsBackendEndpoints/prospectsBackendEndpoints";
import IdentityRepository, {
  IdentityUpdateResult,
} from "@/core/customers/repositories/IdentityRepository";
import { backendMessage } from "@/core/exceptions/backendMessage";

export default class IdentityRepositoryBackend implements IdentityRepository {
  constructor(private readonly httpClient: HttpClient) {}

  /**
   * Le motif du refus remonte avec l'issue.
   *
   * Renvoyer un simple booleen rendait le message du back structurellement intransportable : il
   * etait calcule, puis jete, et l'ecran ne pouvait plus qu'afficher « une erreur est survenue »
   * alors que le back avait nomme le champ fautif.
   */
  async updateIdentityInfos(
    businessKey: string,
    body: object
  ): Promise<IdentityUpdateResult> {
    try {
      const response = await this.httpClient.patch<ApiResponse<unknown>, object>(
        {
          url: updateIdentityInfosUrl(businessKey),
          body,
          withAuth: true,
        }
      );
      const result = ApiResponseHandler.handleResponse(response);
      return {
        success: !!result.success,
        message: result.message ?? null,
      };
    } catch (error) {
      // Un statut non-2xx est jete par la couche HTTP : sans ce rattrapage, l'appelant ne voit
      // qu'une exception anonyme et perd le motif que le back vient de lui donner.
      return { success: false, message: backendMessage(error) };
    }
  }
}
